"use client";
import JoinUs from "@/components/subComponents/joinUs";

export default function JoinUsPage() {
  return <JoinUs />;
}
